<script setup lang="ts">
import { watchEffect } from 'vue'

import { useAuthStore } from '../store'
import { storeToRefs } from 'pinia'
import { AuthenticationStatus } from '../models/types'
import { eventBus } from '@/plugins/eventBus'

const authStore = useAuthStore()

const { status } = storeToRefs(useAuthStore())

const { initateLogout } = useAuthStore()

watchEffect(() => {
  if (status.value === AuthenticationStatus.AUTHENTICATED) {
    eventBus.$emit('startApp', authStore.getInitialRoute())
  }
  if (status.value === AuthenticationStatus.LOGOUT) {
    window.location.replace('/vigo-ot/')
  }
  if (status.value === AuthenticationStatus.ERROR) {
    eventBus.$emit('authError')
  }
})
authStore.authInit()
</script>
<template>
  <v-app>
    <v-layout
      v-if="status === AuthenticationStatus.ERROR"
      class="column justify-space-between wrapper"
    >
      <v-container style="min-height: 95vh" class="d-flex flex-column">
        <v-row>
          <v-col cols="12">
            {{ $t('auth.error') }}
          </v-col>
        </v-row>
      </v-container>
    </v-layout>
    <v-layout
      v-if="status === AuthenticationStatus.AUTHENTICATED"
      class="column justify-space-between wrapper"
    >
      <v-container style="min-height: 95vh" class="d-flex flex-column">
        <v-row>
          <v-col cols="12">
            {{ $t('auth.missing.rights') }}
            <v-btn @click="initateLogout">{{ $t('auth.logout') }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-layout>
  </v-app>
</template>
